import * as React from 'react';
import { Button } from 'reactstrap';
import { SadWolf } from './Icons';
import Panel from './Panel';
import Viewport from './Viewport';
import { ReloadWindow } from '../constants';

export default class UnhandledError extends React.Component<{}> {
  render() {
    return (
      <Viewport>
        <Panel className="min-height-for-loading-indicator">
          <div className="m-3 d-flex justify-content-around">
            <div className="d-flex flex-grow justify-content-end">
              <div
                className="mr-5"
                style={{
                  height: '200px',
                  width: '200px',
                  filter: 'drop-shadow(3px 3px 3px #ccc)',
                }}
              >
                <SadWolf />
              </div>
            </div>
            <div style={{ flexGrow: 2 }}>
              <h1>Arctic Wolf Portal Error</h1>
              <p>
                The portal has encountered an unhandled error. We apologize for
                the inconvenience!
              </p>
              <p>
                This error has been reported to Arctic Wolf so that it can be
                addressed.
              </p>
              <p>Please refresh the browser and try again.</p>
              <Button
                color="primary mt-2"
                size="lg"
                onClick={() => {
                  ReloadWindow();
                }}
              >
                Refresh
              </Button>
            </div>
          </div>
        </Panel>
      </Viewport>
    );
  }
}
